import { BankMatchesType } from '../enums/bankMatchesType'

export const getSelectedTransactionTypes = (transactionType?: BankMatchesType) => {
  if (transactionType === BankMatchesType.Positive) {
    return [BankMatchesType.Positive]
  }

  if (transactionType === BankMatchesType.Negative) {
    return [BankMatchesType.Negative]
  }

  return [BankMatchesType.Positive, BankMatchesType.Negative]
}
